<template>
  <div class="container-mpindex">
    <MpNavbar />
    <MpTitle title="欢迎使用GiiLoo咖啡杯测" intro="点击左侧导航栏进入所选功能" />
    <div class="intro-left">
      <font-awesome-icon icon="arrow-left" />
    </div>
  </div>
</template>

<script>
import MpNavbar from '../../components/mp/navbar'
  import MpTitle from '../../components/mp/title'
  // import { apiName } from '../../request/api'

  export default {
    components: {
      MpNavbar,
      MpTitle
    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
      return {
        loading: false
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {},
      api() {
        let self = this
        apiName({
          page: 1,
          size: 10,
        }).then(res => {
          console.log(res.data)
        }).catch(err => {
          console.log(err)
        })
      },
      go(where) {
        this.$router.push('/'+where)
      },
    }
  }
</script>

<style scoped>
  .container-mpindex {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
    padding-left: 110px;
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
  }
  .intro-left{
    font-size: 40px;
    color: #489D80;
    animation: arrowLeft 1.7s ease infinite;
  }
  @keyframes arrowLeft {
    0%{
      transform: translateX(0)
    }
    15%{transform: translateX(-10px)}
    30%{transform: translateX(0)}
    45%{transform: translateX(-10px)}
    60%{transform: translateX(0)}
    100%{transform: translateX(0)}
  }

</style>